import { makeStyles } from "@mui/styles";

export default makeStyles(theme => ({
  mapContainer: {
    height: "100%",
    margin: -theme.spacing(1) * 3,
  },
}));